import { defineNuxtRouteMiddleware } from '#imports'
import { handleCheckoutCancellation } from '@b2ag/micro-front-checkout-v2-sdk/src/handle-checkout-cancellation'
import { isCheckoutCancellationNeeded } from '@b2ag/micro-front-checkout-v2-sdk/src/is-checkout-cancellation-needed'
import { useLogger } from '@b2ag/utils/src/useLogger'

const logger = useLogger('cancelCheckoutMiddleware')

export default defineNuxtRouteMiddleware(async (to) => {
  if (!import.meta.browser) return

  try {
    if (isCheckoutCancellationNeeded(to.name as string)) await handleCheckoutCancellation()
  } catch (error) {
    logger.error('Error while cancelling checkout', error)
  }
})
